import { docStatus } from 'pages/LoanSubmission/constants'

export const DEFAULT_CHECKLIST_REQUIRED_MESSAGE = 'Checklist must be completed to clear condition'
export const DEFAULT_NOT_REVIEWED_MESSAGE = 'Some documents have not been reviewed yet.'
export const DEFAULT_DOCUMENT_STATUS_BLOCK_MESSAGE = 'Some documents have a status that blocks clearing.'

export interface IConditionClearDocumentStatusRule {
  blockClear: boolean
  message: string
}

export interface IConditionClearRules {
  requireChecklistToClear: boolean
  checklistRequiredMessage: string
  documentStatuses: Record<string, IConditionClearDocumentStatusRule>
}

const defaultStatusRule = (status: string): IConditionClearDocumentStatusRule => ({
  blockClear: status === 'Not Reviewed',
  message: status === 'Not Reviewed' ? DEFAULT_NOT_REVIEWED_MESSAGE : '',
})

export const defaultConditionClearRules = (): IConditionClearRules => {
  const documentStatuses: Record<string, IConditionClearDocumentStatusRule> = {}
  docStatus.forEach((status) => {
    documentStatuses[status] = defaultStatusRule(status)
  })
  return {
    requireChecklistToClear: true,
    checklistRequiredMessage: DEFAULT_CHECKLIST_REQUIRED_MESSAGE,
    documentStatuses,
  }
}

export const normalizeConditionClearRules = (rules: Record<string, any> = {}): IConditionClearRules => {
  const defaults = defaultConditionClearRules()
  const nested = rules.conditionClearRules
  const config: Partial<IConditionClearRules> =
    nested && typeof nested === 'object'
      ? nested
      : rules.documentStatuses || typeof rules.requireChecklistToClear === 'boolean'
        ? (rules as Partial<IConditionClearRules>)
        : {}

  const documentStatuses = { ...defaults.documentStatuses }
  const savedStatuses = config.documentStatuses || {}
  Object.keys(documentStatuses).forEach((status) => {
    const saved = savedStatuses[status]
    if (!saved) return
    documentStatuses[status] = {
      blockClear: !!saved.blockClear,
      message: typeof saved.message === 'string' ? saved.message : documentStatuses[status].message,
    }
  })

  return {
    requireChecklistToClear:
      config.requireChecklistToClear !== undefined ? !!config.requireChecklistToClear : defaults.requireChecklistToClear,
    checklistRequiredMessage:
      typeof config.checklistRequiredMessage === 'string'
        ? config.checklistRequiredMessage
        : defaults.checklistRequiredMessage,
    documentStatuses,
  }
}
